import { PlantPots } from 'images';
import { func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import SplashFeedback from 'utils/old-ui-commons/splash-feedback';

import { reload } from '../../../helpers/window-utils';

const ErrorState = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <SplashFeedback
      imgSrc={PlantPots}
      title={t`Oops! We had a problem`}
      subtitle={
        <>
          <p>{t`The platform had some communication difficulties`}</p>
          <p>{t`reload the page to try again.`}</p>
        </>
      }
      link={{
        type: 'button',
        text: t`reload page`,
        variation: 'alternate',
        onClick,
      }}
    />
  );
};

ErrorState.defaultProps = {
  onClick: () => reload(),
};

ErrorState.propTypes = {
  onClick: func,
};

export default ErrorState;
